import { auth } from "../../typings/auth";
import { STATE } from "../../thor.const";

class AclService {

    public static $inject: string[] = [
        "$q",
        "$translate",
        "authService"
    ];

    private static aclRules = {
        [auth.Roles.Admin]: [
            auth.AclAccess.Analytics,
            auth.AclAccess.Loki,
            auth.AclAccess.Organization,
            auth.AclAccess.OrganizationAuthorization,
            auth.AclAccess.Sales,
            auth.AclAccess.SalesFuture,
            auth.AclAccess.SaleCreate,
            auth.AclAccess.Search,
            auth.AclAccess.Documentation,
            auth.AclAccess.Temis
        ],
        [auth.Roles.Organizations]: [
            auth.AclAccess.Analytics,
            auth.AclAccess.Organization,
            auth.AclAccess.OrganizationAuthorization,
            auth.AclAccess.Sales,
            auth.AclAccess.SalesFuture,
            auth.AclAccess.SaleCreate,
            auth.AclAccess.Search,
            auth.AclAccess.Documentation,
            auth.AclAccess.Temis
        ],
        [auth.Roles.Visitor]: [
            auth.AclAccess.Search
        ]
    };

    // special acl where an organizationId is mandatory
    // could be removed by reorganizing thor routes
    private static aclMandatoryOrganizationId = [
        auth.AclAccess.Organization,
        auth.AclAccess.OrganizationAuthorization,
        auth.AclAccess.Sales,
        auth.AclAccess.SalesFuture,
        auth.AclAccess.SaleCreate,
        auth.AclAccess.Analytics
    ];

    private authorizedPermissions;

    constructor(
        private $q: ng.IQService,
        private $translate: ng.translate.ITranslateService,
        private authService
    ) {}

    public isAllowed(permission) {
        if (!this.authorizedPermissions) {
            return false;
        }

        return this.authorizedPermissions.indexOf(permission) !== -1;
    }

    public isStateAllowed(permission) {
        if (this.isAllowed(permission)) {
            // special case where an organizationId is mandatory
            // could be removed by reorganizing thor routes
            if (
                AclService.aclMandatoryOrganizationId.indexOf(permission) !== -1 &&
                !this.authService.getOrganizationId()
            ) {
                return this.$q.reject({
                    redirectStateName: this.getDefaultState()
                });
            }

            return this.$q.resolve();
        } else {
            return this.$q.reject({
                redirectStateName: this.getDefaultState(),
                toastMessage: this.$translate.instant(
                    "vous_n_avez_pas_les_autorisations_necessaires"
                )
            });
        }
    }

    public initAuthorizedPermissions() {
        this.authorizedPermissions = AclService.aclRules[this.authService.getRole()];
    }

    private getDefaultState() {
        let defaultState;

        switch (this.authService.getRole()) {
            case "admin":
                if (this.authService.getOrganizationId()) {
                    defaultState = STATE.V2.HOME.name;
                } else {
                    defaultState = STATE.V2.LOKI.ORGANIZATIONS;
                }
                break;
            case "organizations":
                defaultState = STATE.V2.HOME.name;
                break;
            case "visitor":
                defaultState = STATE.V2.SEARCH.name;
                break;
            default:
                defaultState = STATE.V2.LOGIN.name;
                break;
        }

        return defaultState;
    }
}

angular
    .module("thor.core.acl.service", [])
    .service("aclService", AclService);
